<template>
    <div
        class="market"
        v-if="!loading && page"
    >
        <component
            :key="layout.id"
            v-for="layout in page.layout"
            :is="layout.acf_fc_layout"
            :layout="layout"
        />
    </div>
</template>

<script>
import PageView from '@/components/MixinPageView'
export default {
    mixins: [PageView],
    watch: {
        '$route'(newVal) {
            this.page = undefined
            this.loading = true
            if(newVal.name === 'Market') {
                this.getPost({
                    slug: this.$route.params.slug,
                    type: 'market',
                    locale: this.$route.params.locale
                })
            }
        },
        '$route.params.locale'(newVal) {
            this.page = undefined
            this.loading = true
            if(newVal.name === 'Market' || newVal.name === 'Markets') {
                this.getPost({
                    slug: this.$route.params.slug,
                    type: 'market',
                    locale: this.$route.params.locale
                })
            }
        }
    },
    created() {
        this.getPost({
            slug: this.$route.params.slug,
            type: this.$route.query.preview ? 'revision' : 'market',
            locale: this.$route.params.locale
        })
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.market
    margin-top: -19.375em
    @include media-breakpoint-down($md)
        margin-top: -16.375em
    @media print
        margin-top: .6cm
        margin-bottom: .6cm
</style>
